import {
    CALCULATION_FAILED,
    CALCULATION_FINISHED,
    CALCULATION_SUCCESS,
    CHANGE_PAGE, CURRENT_LOCATION_SUCCESS, GET_EVENTS_SUCCESS,
    START_CALCULATION
} from "../constants/constants";


const initialState = {
    start: false,
    success: false,
    input: null,
    data: null,
    error: null,
    errorMessage: null,
    page: 0,
    location: null,
    events: null
}

export default function ApplicationReducer (state= initialState, action:any){
    switch (action.type){
        case START_CALCULATION:
            localStorage.setItem("tum_leitfaden_input",JSON.stringify(action.payload))
            return {
                ...state,
                start: true,
                success: initialState.success,
                input:action.payload
            }
        case CALCULATION_SUCCESS:
            localStorage.setItem("tum_leitfaden_result",JSON.stringify(action.payload))
            return {
                ...state,
                start:false,
                success: true,
                data: action.payload
            }
        case CALCULATION_FINISHED:
            localStorage.removeItem("tum_leitfaden_input")
            localStorage.removeItem("tum_leitfaden_result")
            return {
                ...state,
                start:false,
                success: initialState.success,
                data: null
            }
        case CALCULATION_FAILED:
            return {
                ...state,
                start: false,
                error: true,
                errorMessage: action.payload
            }
        case CHANGE_PAGE:
            return {
                ...state,
                page: action.payload
            }
        case GET_EVENTS_SUCCESS:
            return {
                ...state,
                events: action.payload
            }
        case CURRENT_LOCATION_SUCCESS:
            return {
                ...state,
                location: action.payload
            }
        default:
            return state;
    }
}
